import { xAdd, xMaxValue } from 'ml-spectra-processing';
/**
 * Filter that allows to
 * @param data
 * @param options
 */
export function setMaxX(data, options = {}) {
    const { max = 1 } = options;
    const existingMax = xMaxValue(data.x);
    if (existingMax === max) {
        return { data };
    }
    return {
        data: {
            x: xAdd(data.x, max - existingMax),
            y: data.y,
        },
    };
}
//# sourceMappingURL=setMaxX.js.map